angular.module('unica_auth.auth_controllers')

.controller('ErrorController', function( $rootScope, $scope ) {

	$scope.checkUserAuth({});
});